import { sgwtConnect } from '../services/sgwt-connect';

const serverDataBaseUrl = import.meta.env.VITE_APP_SERVER_DATA;
const serverDirectoryBaseUrl = import.meta.env.VITE_APP_SERVER_DIRECTORY;
const serverPlanBaseUrl = import.meta.env.VITE_APP_SERVER_PLAN;

export const API = {
  SITES: {
    GET_SITES: `${serverDataBaseUrl}/cbws/sg/v2/intranet/`,
    GET_SITE_INFORMATIONS: `${serverDataBaseUrl}/cbws/sg/v2/intranet/:idFolderSite/full-config`,
    GET_SITE_HELP: `${serverDataBaseUrl}/cbws/sg/v2/intranet/:idFolderSite/page-aide`,
  },
  SPACES: {
    GET_BUILDING: `${serverDataBaseUrl}/cbws/sg/v2/sites/`,
    GET_TABLE_PSIZNL: `${serverDataBaseUrl}/cbws/sg/v2/sites/:idFolderSite/tablePSIZNLmap`,
    GET_WORKSPACES: `${serverDataBaseUrl}/cbws/sg/v2/spaces/workspaces`,
  },
  ARTICLES: {
    GET_LAVALLEE: `${serverDataBaseUrl}/cbws/sg/v3/articles/`,
  },
  RESTAURATION: {
    GET_RESTAURATION: `${serverDataBaseUrl}/cbws/sg/v3/restauration/`,
  },
  SMART_OFFICE: {
    GET_LOCAUX: `${serverDataBaseUrl}/cbws/sg/v2/spaces/locaux`,
    WS_AUTH: `${serverDataBaseUrl}/cbws/IControle_WebServices.svc/`,
  },
  DOMOTIQUE: {
    GET_AC_OFFSET: `${serverDataBaseUrl}/IControle_WebServices.svc/GetAC_Offset`,
    TEMPERATURE: `${serverDataBaseUrl}/IControle_WebServices.svc/ControlAC_Offset`,
    BLINDS: `${serverDataBaseUrl}/IControle_WebServices.svc/ControlBlinds`,
    LIGHTS: `${serverDataBaseUrl}/IControle_WebServices.svc/ControlLighting`,
  },
  MAPS: {
    GET_ALL_SPACES: `${serverDataBaseUrl}/cbws/sg/v2/spaces/locauxShort`,
    GET_ROOM_OCCUPATION: `${serverDataBaseUrl}/cbws/sg/v2/spaces/occupation`,
    GET_WORKSPACE_OCCUPATION: `${serverDataBaseUrl}/cbws/sg/v2/spaces/workspaces`,
  },
  BOOKING: {
    SEARCH_AVAILABLE_DESKS: `${serverDataBaseUrl}/cbws/sg/v3/workplace/search`,
    WORKPLACE_BOOKING: `${serverDataBaseUrl}/cbws/sg/v3/workplace/bookings`,
    GET_ALL_SERVICES: `${serverDataBaseUrl}/cbws/sg/v3/workplace/services`,
    GET_LOCAUX_SHORT: `${serverDataBaseUrl}/cbws/sg/v2/spaces/locauxShort`,
    WORKPLACE_SHARING: `${serverDataBaseUrl}/cbws/sg/v3/workplace/sharing`,
    BOOKING_SHARING: `${serverDataBaseUrl}/cbws/sg/v3/workplace/sharing/bookings`,
  },
  DIRECTORY: {
    SEARCH_PEOPLE: `${serverDirectoryBaseUrl}/people/api/v2/people/partial`,
    GET_PERSON: `${serverDirectoryBaseUrl}/people/api/v1/people`,
  },
  INTRANET: {
    GET_ADDITIONAL_CONFIG: `${serverDataBaseUrl}/cbws/sg/v3/intranet/additional-config`,
    GET_ACCESSIBILITY: `${serverDataBaseUrl}/cbws/sg/v3/intranet/accessibility`,
  },
  VERSION: {
    GET_VERSION: `${serverDataBaseUrl}/cbws/public/sg/v3/application/version`,
  },
  PLAN : {
    GET_PLAN: `${serverPlanBaseUrl}/atlas/api/v1/desks/getplanfile`,
  },
};

export const accessibilityRoute = '/accessibility';
export const servicesRoute = '/services';
export const smartBuildingRoute = '/smartbuilding';
export const availableDesksRoute = '/availabledesks';
export const reservationRoute = '/reservation';
export const MapsFromAvailableDesks = '/mapsFromAvailableDesks';

export const buildSgConnectAuthorizationHeaders = () => {
  return {
    Authorization: sgwtConnect.getAuthorizationHeader(),
  };
};

export const buildDataServerAuthorizationHeaders = () => {
  return {
    Authorization: sgwtConnect.getAuthorizationHeader(),
    'X-Authentication-Provider': 'SGCONNECT',
  };
};

export const buildDataServerJsonContentHeaders = () => {
  return {
    Authorization: sgwtConnect.getAuthorizationHeader(),
    'X-Authentication-Provider': 'SGCONNECT',
    'content-type': 'application/json',
  };
};
